<template>
  <el-container class="main_container">
    <base-header>
      <el-button @click="dialogVisible = true" type="primary">添加代理商</el-button>
    </base-header>
    <el-main>
      <el-table :data="agent_list" style="width: 100%" height="100%">
        <el-table-column fixed prop="date" label="头像昵称" width="150">
          <template v-slot="scope">
            <div class="clickable" @click="toUserManager(scope.row.client_id)">
              <img class="avatar-img" v-if="scope.row.avatar_url" :src=scope.row.avatar_url>
              {{scope.row.nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="client_id" label="UserID" width="120">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120">
        </el-table-column>
        <el-table-column label="销售额" width="120">
          <template v-slot="scope">
            <div>
              ￥{{scope.row.sale_price}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="优惠码" width="300">
          <template v-slot="scope">
            <div>
              <el-button type="primary" plain @click="couponDialog(scope.row)">管理优惠码</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="账单" width="120">
           <template v-slot="scope">
            <div>
              <el-button type="primary" @click="exportAgentBill(scope.row)" plain>查看账单</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
    <dialog-modal :show.sync="dialogVisible" @getList="getList"/>
    <coupon-code :couponshow.sync="couponVisible" :promo_code_data="promo_code_data" :client_id="client_id" @getPromoCode="getPromoCode(client_id)"/>
  </el-container>
</template>

<script>
import DialogModal from './components/DialogModal'
import CouponCode from './components/CouponCode'
import pageMixin from '../../../mixins/page'
import getTokenMixin from '../../../mixins/getToken'
export default {
  components: { DialogModal, CouponCode },
  mixins: [pageMixin, getTokenMixin],
  data () {
    return {
      dialogVisible: false, // 添加代理商弹框的显示隐藏
      couponVisible: false, // 优惠码弹框的显示隐藏
      AgentListURL: this.getDomain() + 'bmagent/get_agent_list', // 代理商列表
      PromoCodeURL: this.getDomain() + 'bmagent/get_promo_code_list', // 获取优惠码列表
      exportAgentBillURL: this.getDomain() + 'bmagent/export_agent_bill', // 导出代理商总账单
      agent_list: [], // 代理商列表数据
      promo_code_data: [], // 优惠码列表
      client_id: undefined
    }
  },
  methods: {
    getList () {
      let params = {
        page: this.page,
        pagesize: this.pagesize
      }
      let handle = res => {
        this.totalCount = res.data.content.total_count
        this.agent_list = res.data.content.agent_data
        this.agent_list.forEach(item => {
          item.sale_price = item.sale_price / 100
        })
      }
      this.__axios(this.AgentListURL, params, handle)
    },
    couponDialog (row) {
      this.couponVisible = true
      this.client_id = row.client_id
      this.getPromoCode(row.client_id)
    },
    getPromoCode (clientId) {
      let params = {
        client_id: clientId
      }
      let handle = res => {
        this.promo_code_data = res.data.content
        res.data.content.promo_code_data.forEach(item => {
          item.seller_price = item.seller_price / 100
          item.brander_price = item.brander_price / 100
          this.$set(item, 'visible', false)
        })
      }
      this.__axios(this.PromoCodeURL, params, handle)
    },
    exportAgentBill (row) {
      let params = {
        client_id: row.client_id
      }
      let handle = res => {
        window.open(res.data.content.url)
      }
      this.__axios(this.exportAgentBillURL, params, handle)
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
  .avatar-img {
    width: 40px;
    height: 40px;
    vertical-align: middle;
  }
</style>
